// extracted by mini-css-extract-plugin
module.exports = {"small":"480px","medium":"768px","large":"1024px","extraLarge":"1200px","max":"1520px"};